module.exports = __webpack_public_path__ + "img/Psychology4.38306423.png";